import * as actionTypes from './actiontypes'
import states from './states'

const conversion_details = (state = states.conversion_details, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_CONVERSION_STATE:
      return {
        ...state,
        ...action.payload
      }

    case actionTypes.FUNNEL_DATA_LOADED: {
      return {
        ...state,
        funnel_data: action.payload.salesFunnelAnalyticsData,
        top_conversion_drivers: action.payload.topConversionDrivers,
        funnel_data_loading: false,
        funnel_data_load_error: false,
      }
    }

    default:
      return state
  }
}

export default conversion_details



// WEBPACK FOOTER //
// ./src/data/redux/conversion_details/reducers.js